export type ProductType = 'normal' | 'promo';
export enum ProductTypes {
  NORMAL = 'normal',
  PROMO = 'promo',
}
